<p-dropdown
  [options]="filteredOptions()"
  [ngModel]="model()"
  (ngModelChange)="onModelChange($event)"
  (onShow)="onShow()"
  (onHide)="onHide()"
  optionLabel="label"
  [editable]="true"
  [showClear]="showClear()"
  [placeholder]="placeholder()"
  [disabled]="disabled"
  [appendTo]="appendTo()"
  [panelStyleClass]="panelStyleClass()"
  [styleClass]="class()"
  [overlayOptions]="{
    style: { margin: '0', top: 'calc(100% + 3px)', left: '0', transform: 'none' },
    contentStyle: { margin: '0', padding: '0' }
  }"
  class="editable-dropdown"
>
  <ng-template let-option pTemplate="item">
    <div class="flex-container">
      <span>{{ option.label }}</span>
    </div>
  </ng-template>
</p-dropdown>
